
export default interface ImplementationUserLabels {
  User1: string;
  User2: string;
  User3: string;
  User4: string;
  User5: string;
  User6: string;
  User7: string;
  User8: string;
  User9: string;
  User10: string;
}



export function CreateEmptyImplementationUserLabels(): ImplementationUserLabels {
  const result: ImplementationUserLabels = {
    User1: "",
    User2: "",
    User3: "",
    User4: "",
    User5: "",
    User6: "",
    User7: "",
    User8: "",
    User9: "",
    User10: ""
  }
  return result
}

